import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { getLayoutProps } from '@/utils/layout/layout';
import User from '@/store/user';
import PageLayout from '@/components/PageLayout';
import NotificationsPage from '@/components/NotificationsPage/NotificationsPage.jsx';

export default function Notifications({ responsiveLogo, card }) {
  const [user, setUser] = useState();

  const router = useRouter();
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/login');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  if (!user?._id) return null;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <NotificationsPage />
    </>
  );
}

Notifications.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'loyalty'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, locale);

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_notifications: (await import(`../../../../prebuild-data/i18n/${locale}/user_notifications.json`)).default,
    account_details: (await import(`../../../../prebuild-data/i18n/${locale}/account_details.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
    },
  };
}
